import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import React from 'react';
import PaypalLoginLogo from '../assets/images/paypal_white_logo.png';

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  position: 'static',
  color: theme.palette.getContrastText('#FE2C55'),
  borderRadius: theme.spacing(1.25),
  height: 55,
  top: '45vh',
  width: '90%',
  backgroundColor: lightBlue[700],
  '&:hover': {
    backgroundColor: lightBlue[700],
  },
  '&.MuiButton-contained': {
    fontWeight: 600,
    fontSize: theme.spacing(2),
  },
  '&:disabled': {
    backgroundColor: lightBlue[700],
    opacity: '0.4',
    color: theme.palette.common.white,
  },
  [theme.breakpoints.up('sm')]: {
    marginLeft: '5vw',
    width: '40%',
  },
}));

type ConnectWithPaypalCTAProps = {
  text?: string | JSX.Element;
  showLoader?: boolean;
  disable?: boolean;
  onBtnClick?: () => void;
  optionalStackStyles?: {
    [key: string]: unknown
  },
} & ButtonProps;

export default function ConnectWithPaypalCTA({
  text,
  showLoader,
  disable = false,
  onBtnClick,
  optionalStackStyles,
  ...props
}: ConnectWithPaypalCTAProps) {
  const theme = useTheme();
  const handleOnClick = () => {
    if (onBtnClick) {
      onBtnClick();
    }
  };
  return (
    <Stack spacing={2} direction="row">
      <ColorButton variant="contained" onClick={handleOnClick} {...props} disabled={disable}>
        {!showLoader &&
          <img src={PaypalLoginLogo} alt="DisabledShareIcon"
            style={{
              marginRight: theme.spacing(1),
            }}
          />
        }
        {text}
      </ColorButton>
    </Stack>
  );
}
